import React, { useState } from 'react';

function DownloadPopupComponent({ isOpen, onClose, onConfirm }) {
    const [includeAttachments, setIncludeAttachments] = useState(false);

    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm({ includeAttachments });
    };

    return (
        <div className="download-popup-overlay">
            <div className="download-popup-container">
                <div className="download-popup-icon-wrap">
                    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="64" height="64" rx="32" fill="#ebf0f9" />
                        <path d="M38 20H22C20.8954 20 20 20.8954 20 22V42C20 43.1046 20.8954 44 22 44H42C43.1046 44 44 43.1046 44 42V26L38 20Z" stroke="#2d6cb2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M38 20V26H44" stroke="#2d6cb2" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M32 29V37M28 33L32 37L36 33" stroke="#112e53" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                
                <h3 className="download-popup-title">Download Reports</h3>
                
                <div className="download-popup-list">
                    <div className="download-popup-item font-bold" onClick={() => setIncludeAttachments(!includeAttachments)}>
                        <span className={`checkbox-custom ${includeAttachments ? 'checked' : ''}`}></span>
                        <span className="checkbox-label font-bold">Include Attachments as (.ZIP)</span>
                    </div>
                </div>

                <div className="download-popup-buttons">
                    <button className="download-popup-btn btn-cancel" onClick={onClose}>CANCEL</button>
                    <button className="download-popup-btn btn-confirm" onClick={handleConfirm}>CONFIRM</button>
                </div>
            </div>
        </div>
    );
}

export default DownloadPopupComponent;
